import { render, staticRenderFns } from "./UploadProfilePhoto.vue?vue&type=template&id=26c0b544&"
import script from "./UploadProfilePhoto.vue?vue&type=script&lang=js&"
export * from "./UploadProfilePhoto.vue?vue&type=script&lang=js&"
import style0 from "./UploadProfilePhoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports